// https://www.cssfontstack.com/
export enum MeshCellFontName
{
    Arial = 'Arial',
    Calibri = 'Calibri',
    Tahoma = 'Tahoma',
    Georgia = 'Georgia',
    Verdana = 'Verdana',
    CourierNew = 'Courier New',
    TimesNewRoman = 'Times New Roman',
    TrebuchetMS = 'Trebuchet MS',
    ComicSansMS = 'Comic Sans MS',

    OpenSans = 'Open Sans',
    OpenSansCondensed = 'Open Sans Condensed',

    Roboto = 'Roboto',
    RobotoMono = 'Roboto Mono',
    RobotoCondensed = 'Roboto Condensed',

    Montserrat = 'Montserrat',
}
